import { claimCountryDefine } from '@/lib/define/claim-country-define'
import BigNumber from 'bignumber.js'
import { DetailsState, DetailsItemType } from '@/@types/billing/details'

export const useBasicCalcAddition = () => {
  const handleGetTargetArrayBasicServiceCode = (targetServiceType: string) => {
    switch (targetServiceType) {
      case '61':
        return claimCountryDefine.TARGET_ARRAY_61_BASIC

      case '63':
        return claimCountryDefine.TARGET_ARRAY_63_BASIC

      case '64':
        return claimCountryDefine.TARGET_ARRAY_64_BASIC
    }
  }

  const handleBasicRewardFilter = (
    details: DetailsItemType[],
    targetServiceType: string
  ) => {
    const TARGET_ARRAY_BASIC = handleGetTargetArrayBasicServiceCode(
      targetServiceType
    )

    let handleBasicRewardFilterArray: DetailsItemType[] = []

    if (TARGET_ARRAY_BASIC) {
      handleBasicRewardFilterArray = details.filter((data: any) =>
        TARGET_ARRAY_BASIC.find(
          (subData: any) => String(subData) === String(data.beServiceCode)
        )
      )

      console.log(
        '----------------------------------start 対象のサービスコード一覧'
      )
      console.log(TARGET_ARRAY_BASIC.length)
      for (
        let index = 0;
        index < handleBasicRewardFilterArray.length;
        index++
      ) {
        console.log(handleBasicRewardFilterArray[index].beServiceCode)
      }
      console.log(
        '----------------------------------end 対象のサービスコード一覧'
      )
    }

    return handleBasicRewardFilterArray
  }

  // 令和３年９月３０日までの上乗せ分の計算
  const valueCovidZZ01CalculationSet = (details: DetailsState) => {
    const targetZZ01Array = details.details.filter(
      (data: DetailsItemType) => String(data.beServiceCode).slice(2) === 'ZZ01'
    )

    if (targetZZ01Array.length !== 0) {
      targetZZ01Array.forEach((targetZZ01: any) => {
        let targetServiceType = ''

        switch (targetZZ01.beServiceCode) {
          case '61ZZ01':
            targetServiceType = '61'
            break
          case '63ZZ01':
            targetServiceType = '63'
            break
          case '64ZZ01':
            targetServiceType = '64'
            break
        }

        if (targetServiceType) {
          const filterZZ01TargetArray = handleBasicRewardFilter(
            details.details,
            targetServiceType
          )

          targetZZ01.beCount = 1

          const targetBeServiceUnitsArray = filterZZ01TargetArray.map(
            (data: any) => data.beServiceUnits
          )

          let targetZZ01BeUnits = 0

          for (
            let index = 0;
            index < targetBeServiceUnitsArray.length;
            index++
          ) {
            if (
              targetBeServiceUnitsArray[index] ||
              targetBeServiceUnitsArray[index] === 0
            ) {
              targetZZ01BeUnits += Number(targetBeServiceUnitsArray[index])
            }
          }

          targetZZ01.beUnits = Math.round(
            Number(new BigNumber(targetZZ01BeUnits).times(0.001))
          )

          if (
            targetZZ01.beUnits === 0 &&
            targetBeServiceUnitsArray.some((data: any) => Number(data) !== 0)
          ) {
            targetZZ01.beUnits = 1
          }

          if (filterZZ01TargetArray.length === 0) {
            targetZZ01.beUnits = 0
          }
        }
      })
    }
  }

  // 身体拘束廃止未実施減算の計算
  const valueSubtractionZ001CalculationSet = (details: DetailsState) => {
    const targetZ001Array = details.details.filter(
      (data: any) => String(data.beServiceCode).slice(2) === 'Z001'
    )

    if (targetZ001Array.length !== 0) {
      targetZ001Array.forEach((targetZ001: any) => {
        let targetServiceType = ''

        switch (targetZ001.beServiceCode) {
          case '61Z001':
            targetServiceType = '61'
            break
          case '63Z001':
            targetServiceType = '63'
            break
          case '64Z001':
            targetServiceType = '64'
            break
        }

        if (targetServiceType) {
          const filterZ001TargetArray = handleBasicRewardFilter(
            details.details,
            targetServiceType
          )

          targetZ001.beUnits = -5

          const targetBeServiceUnitsArray = filterZ001TargetArray.map(
            (data: any) => data.beCount
          )

          let target63Z001BeCount = 0

          for (
            let index = 0;
            index < targetBeServiceUnitsArray.length;
            index++
          ) {
            if (
              targetBeServiceUnitsArray[index] ||
              targetBeServiceUnitsArray[index] === 0
            ) {
              target63Z001BeCount += Number(targetBeServiceUnitsArray[index])
            }
          }

          targetZ001.beCount = target63Z001BeCount
        }
      })
    }
  }

  return {
    handleBasicRewardFilter,
    valueCovidZZ01CalculationSet,
    valueSubtractionZ001CalculationSet,
  }
}
